import React, { Fragment } from 'react';

import UFOSegment from '@atlaskit/react-ufo/segment';

import { PageSegmentLoadEnd } from '@confluence/browser-metrics/entry-points/PageSegmentLoadEnd.ts';
import { PageSegmentLoadStart } from '@confluence/browser-metrics/entry-points/PageSegmentLoadStart.ts';
import { Attribution } from '@confluence/error-boundary/entry-points/Attribution.ts';
import { ErrorBoundary } from '@confluence/error-boundary/entry-points/ErrorBoundary.ts';

import { AdvancedSearchController } from './AdvancedSearchController.tsx';
import { ADVANCED_SEARCH_COMPONENT_PAGE_SEGMENT_LOAD } from './perf.config.ts';

export function AdvancedSearch(): React.JSX.Element {
	return (
		<Fragment>
			<UFOSegment name="advanced-search">
				<PageSegmentLoadStart metric={ADVANCED_SEARCH_COMPONENT_PAGE_SEGMENT_LOAD} />
				<ErrorBoundary attribution={Attribution.DISCO}>
					<AdvancedSearchController />
				</ErrorBoundary>
				<PageSegmentLoadEnd metric={ADVANCED_SEARCH_COMPONENT_PAGE_SEGMENT_LOAD} />
			</UFOSegment>
		</Fragment>
	);
}
